import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Título opcional renderizado como encabezado de la tarjeta. */
  title?: string;
  /** Contenido del pie (acciones, metadatos). */
  footer?: ReactNode;
}

/**
 * Tarjeta base sobre Gris Evidencia. Superficie elevada, borde sobrio.
 * Sin sombras agresivas: contenedor institucional, no producto llamativo.
 */
export function Card({ children, title, footer, className, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-surface-raised shadow-sm',
        className,
      )}
      {...rest}
    >
      {title && (
        <div className="border-b border-border px-5 py-3">
          <h3 className="font-display text-lg font-semibold text-content">
            {title}
          </h3>
        </div>
      )}
      <div className="px-5 py-4">{children}</div>
      {footer && (
        <div className="border-t border-border px-5 py-3 text-sm text-content-muted">
          {footer}
        </div>
      )}
    </div>
  );
}
